export default window.location.origin === 'https://transloadit.com'
